<ng-container *ngFor="let module of tableModules">
  <i
    *ngIf="MODULES_ICON[module.name]"
    [class]="'icon-module ' + MODULES_ICON[module.name]"
    aria-hidden="true"
    [appCustomTooltip]="module.total"
  ></i>
</ng-container>
